import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { getTicketsList } from "../../redux/ticket/slice";
import { useDispatch, useSelector } from "react-redux";
import CreateQuickTicket from "./createQuickTicket/CreateQuickTicket";
import AllTickets from "./components/AllTickets";
import Breadcrumb from "../../commons/Breadcrumb";
import {
  ArchiveIcon,
  EmailUnreadIcon,
  MarkEmailReadIcon,
  MarkEmailUnreadIcon,
  MarkunreadMailbox,
  Plus,
} from "../../assets/svg/AllSvg";
import DebounceSearch from "../../commons/DebounceSearch";
import RippleLoader from "../../commons/RippleLoader";
import DataNotFound from "../../commons/DataNotFound";
import TableShowLimit from "../../commons/TableShowLimit";
import Pagination from "../../commons/Pagination";
import ReplyTicket from "./replyTicket/ReplyTicket";

const Tickets = () => {
  const [selectedPriority, setSelectedPriority] = useState();
  const [selectedPeriod, setSelectedPeriod] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [createQuickTicketModel, setCreateQuickTicketModel] = useState(false);
  const [replyTicketModel, setReplyTicketModel] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [ticketData, setTicketData] = useState({});
  const [activeTab, setActiveTab] = useState("All Tickets");
  const dispatch = useDispatch();

  // selector
  const { ticketList, ticketListLoading } = useSelector((store) => ({
    ticketList: store?.ticketData?.getTicketsListStatus?.data?.data,
    ticketListLoading: store?.ticketData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getTicketsList({
        search: searchValue,
        priority: selectedPriority?.value ?? "",
        period: selectedPeriod?.value ?? "",
        pageCount: pageCount,
        pageLimit: pageLimit,
        status:
          activeTab === "New"
            ? "new"
            : activeTab === "On-Going"
            ? "on_going"
            : activeTab === "Resolved"
            ? "resolved"
            : activeTab === "Archived"
            ? "archived"
            : "",
      })
    );
  }, [
    dispatch,
    searchValue,
    selectedPriority,
    selectedPeriod,
    pageCount,
    pageLimit,
    activeTab,
  ]);

  const tab = [
    {
      id: 0,
      name: "All Tickets",
      count:
        (ticketList?.counts?.new ? ticketList?.counts?.new : 0) +
        (ticketList?.counts?.on_going ? ticketList?.counts?.on_going : 0) +
        (ticketList?.counts?.resolved ? ticketList?.counts?.resolved : 0) +
        (ticketList?.counts?.archived ? ticketList?.counts?.archived : 0),
    },
    {
      id: 1,
      name: "New",
      count: ticketList?.counts?.new ?? 0,
    },
    {
      id: 2,
      name: "On-Going",
      count: ticketList?.counts?.on_going ?? 0,
    },
    {
      id: 3,
      name: "Resolved",
      count: ticketList?.counts?.resolved ?? 0,
    },
    {
      id: 4,
      name: "Archived",
      count: ticketList?.counts?.archived ?? 0,
    },
  ];

  return (
    <>
      <div className="space-y-5">
        <div>
          <h6 className="font-ebGaramond font-semibold text-2xl mb-3">
            Tickets
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbActive={"Tickets"}
            breadCrumbTitleKey={"/"}
            classes=""
          />
        </div>
        <div className="w-full bg-white border rounded sm:space-y-4 space-y-3 py-5 px-6">
          <div className="sm:flex justify-between">
            <p className="font-ebGaramond lg:text-2xl text-xl mb-3">
              SGCorpHub Tickets
            </p>
            <button
              className="btn-theme flex items-center uppercase"
              onClick={() => {
                setCreateQuickTicketModel(true);
              }}
            >
              <Plus className="mr-2" /> New Ticket
            </button>
          </div>
          <div className="sm:flex justify-between gap-3 sm:space-y-0 space-y-2">
            {/* Search */}
            <DebounceSearch
              search={searchValue}
              handleChange={setSearchValue}
              placeholder={"Search..."}
            />
            <div className="flex sm:max-w-xs w-full gap-3">
              {/* Priority Filter */}
              <ReactSelect
                className={
                  "w-full sm:max-w-md text-black lg:text-base sm:text-sm text-xs p-0"
                }
                id="priorityDropdown"
                placeholder="Priority"
                options={[
                  {
                    label: "Low Priority",
                    value: "low",
                  },
                  {
                    label: "Mid Priority",
                    value: "mid",
                  },
                  {
                    label: "High Priority",
                    value: "high",
                  },
                ]}
                isLoading={false}
                getOptionValue={(selectedPriority) => selectedPriority.value}
                value={selectedPriority}
                onChange={(e) => {
                  setSelectedPriority(e);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: `1px solid #cdddeb`,
                    borderRadius: "0.3rem",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #cdddeb",
                    },
                  }),
                }}
              />
              {/* Period Filter */}
              <ReactSelect
                className={
                  "w-full sm:max-w-xs text-black lg:text-base sm:text-sm text-xs p-0"
                }
                id="period"
                placeholder="Period"
                options={[
                  { label: "This Week", value: "this_week" },
                  { label: "This Month", value: "this_month" },
                  { label: "All", value: "all" },
                ]}
                isLoading={false}
                getOptionValue={(selectedPeriod) => selectedPeriod.value}
                value={selectedPeriod}
                onChange={(e) => {
                  setSelectedPeriod(e);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: `1px solid #cdddeb`,
                    borderRadius: "0.3rem",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #cdddeb",
                    },
                  }),
                }}
              />
            </div>
          </div>
          {/* Tab Buttons */}
          <div className={`flex flex-wrap border-b`}>
            {tab.map((tab, index) => (
              <button
                key={index}
                className={`py-2 px-4 capitalize group flex items-center border-b-2 transition duration-300 lg:text-base sm:text-sm text-xs gap-2 ${
                  activeTab === tab.name
                    ? "border-theme text-theme"
                    : "border-transparent hover:text-theme text-light_grey hover:border-theme op"
                }`}
                onClick={() => setActiveTab(tab.name)}
              >
                {tab.name === "All Tickets" ? (
                  <MarkunreadMailbox
                    className="lg:w-5 w-4"
                    fillOpacity={activeTab === "All Tickets" ? 1 : null}
                    fillClass={
                      activeTab === "All Tickets"
                        ? "fill-theme"
                        : "transition duration-300 group-hover:fill-theme group-hover:opacity-100"
                    }
                  />
                ) : tab.name === "New" ? (
                  <MarkEmailUnreadIcon
                    className="lg:w-5 w-4"
                    fillOpacity={activeTab === "New" ? 1 : null}
                    fillClass={
                      activeTab === "New"
                        ? "fill-theme"
                        : "transition duration-300 group-hover:fill-theme group-hover:opacity-100"
                    }
                  />
                ) : tab.name === "On-Going" ? (
                  <EmailUnreadIcon
                    className="lg:w-5 w-4"
                    fillOpacity={activeTab === "On-Going" ? 1 : null}
                    fillClass={
                      activeTab === "On-Going"
                        ? "fill-theme"
                        : "transition duration-300 group-hover:fill-theme group-hover:opacity-100"
                    }
                  />
                ) : tab.name === "Resolved" ? (
                  <MarkEmailReadIcon
                    className="lg:w-5 w-4"
                    fillOpacity={activeTab === "Resolved" ? 1 : null}
                    fillClass={
                      activeTab === "Resolved"
                        ? "fill-theme"
                        : "transition duration-300 group-hover:fill-theme group-hover:opacity-100"
                    }
                  />
                ) : (
                  <ArchiveIcon
                    className="lg:w-5 w-4"
                    fillOpacity={activeTab === "Archived" ? 1 : null}
                    fillClass={
                      activeTab === "Archived"
                        ? "fill-theme"
                        : "transition duration-300 group-hover:fill-theme group-hover:opacity-100"
                    }
                  />
                )}
                {tab.name}
                <p>{tab.count}</p>
              </button>
            ))}
          </div>
          {/* Ticket List */}
          {ticketListLoading ? (
            <RippleLoader />
          ) : (
            <>
              {ticketList?.tickets?.data?.length ? (
                <>
                  {ticketList?.tickets?.data?.map((element) => {
                    return (
                      <AllTickets
                        element={element}
                        setReplyTicketModel={setReplyTicketModel}
                        setTicketData={setTicketData}
                        searchValue={searchValue}
                        selectedPriority={selectedPriority}
                        selectedPeriod={selectedPeriod}
                        pageCount={pageCount}
                        pageLimit={pageLimit}
                        listStatus={
                          activeTab === "New"
                            ? "new"
                            : activeTab === "On-Going"
                            ? "on_going"
                            : activeTab === "Resolved"
                            ? "resolved"
                            : activeTab === "Archived"
                            ? "archived"
                            : ""
                        }
                      />
                    );
                  })}
                </>
              ) : (
                <DataNotFound />
              )}
            </>
          )}
          {/* Pagination */}
          {ticketList?.tickets ? (
            <div className="flex flex-wrap items-center justify-end sm:my-2 my-1">
              <TableShowLimit
                paginationCurrentLimit={pageLimit}
                setPaginationCurrentLimit={setPageLimit}
              />
              <p className="text-xs">
                {(ticketList?.tickets?.current_page - 1) *
                  ticketList?.tickets?.per_page +
                  1}{" "}
                -{" "}
                {(ticketList?.tickets?.current_page - 1) *
                  ticketList?.tickets?.per_page +
                  ticketList?.tickets?.data?.length}{" "}
                of {ticketList?.tickets?.total}
              </p>
              <div className="px-4 py-2 rounded-lg">
                <Pagination
                  total={ticketList?.tickets?.total}
                  current={pageCount}
                  pagination={(crPage) => setPageCount(crPage)}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {/* Create Quick Ticket */}
      {createQuickTicketModel && (
        <CreateQuickTicket
          setCreateQuickTicketModel={setCreateQuickTicketModel}
          searchValue={searchValue}
          selectedPriority={selectedPriority}
          selectedPeriod={selectedPeriod}
          pageCount={pageCount}
          pageLimit={pageLimit}
          status={
            activeTab === "New"
              ? "new"
              : activeTab === "On-Going"
              ? "on_going"
              : activeTab === "Resolved"
              ? "resolved"
              : activeTab === "Archived"
              ? "archived"
              : ""
          }
        />
      )}
      {/* Reply Ticket */}
      {replyTicketModel && (
        <ReplyTicket
          setReplyTicketModel={setReplyTicketModel}
          ticketData={ticketData}
          searchValue={searchValue}
          selectedPriority={selectedPriority}
          selectedPeriod={selectedPeriod}
          pageCount={pageCount}
          pageLimit={pageLimit}
          status={
            activeTab === "New"
              ? "new"
              : activeTab === "On-Going"
              ? "on_going"
              : activeTab === "Resolved"
              ? "resolved"
              : activeTab === "Archived"
              ? "archived"
              : ""
          }
        />
      )}
    </>
  );
};
export default Tickets;
